export default __webpack_public_path__ + "static/3_3-718e3e0b8499bf6434f9f406e2f7b2cf.png";